import { FC } from "react";
import { Flex, Switch, Text } from "@chakra-ui/react";
import { AlertDialogConfig } from "../../../types/Components/Alert/AlertDialogConfig";

interface SwitchComponentProps {
  isActive: boolean;
  onChange: (value: any, isActive: boolean) => void;
  value: any;
  color: string;
  isDisabled?: boolean;
  alertDialogConfig?: AlertDialogConfig;
}

const SwitchComponent: FC<SwitchComponentProps> = ({
  isActive,
  onChange,
  value,
  color,
  isDisabled = false,
}) => {
  const handleChange = () => {
    onChange(value, !isActive);
  };

  return (
    <Flex gap="3" alignItems="center">
      <Switch
        isChecked={isActive}
        onChange={handleChange}
        size="sm"
        sx={{
          "& .chakra-switch__track": {
            _checked: {
              backgroundColor: color,
            },
          },
        }}
        isDisabled={isDisabled}
      />
      <Text minWidth="20" flexGrow={1}>
        {isActive ? "Ativo" : "Inativo"}
      </Text>
    </Flex>
  );
};

export default SwitchComponent;
